import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';
import { cn } from '@/lib/utils';

export type AppsCatalogTab = 'apps' | 'sections' | 'preview';

const TABS: { id: AppsCatalogTab; label: string; to: string }[] = [
  { id: 'apps', label: 'Apps', to: '/admin/apps-catalog' },
  { id: 'sections', label: 'Sections', to: '/admin/apps-catalog/sections' },
  { id: 'preview', label: 'Preview', to: '/admin/apps-catalog/preview' },
];

/** Title, description and Apps / Sections / Preview tabs shared by the catalog pages. */
export const AppsCatalogHeader = ({
  active,
  description,
  actions,
}: {
  active: AppsCatalogTab;
  description: ReactNode;
  actions?: ReactNode;
}) => (
  <div className="space-y-4">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900">
          <LayoutGrid className="h-6 w-6 text-blue-700" />
          Apps catalog
        </h1>
        <p className="mt-1 max-w-3xl text-sm text-gray-500">{description}</p>
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
    <nav className="flex gap-1 overflow-x-auto border-b border-gray-200">
      {TABS.map((tab) => (
        <Link
          key={tab.id}
          to={tab.to}
          className={cn(
            '-mb-px whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors',
            active === tab.id
              ? 'border-blue-600 text-blue-700'
              : 'border-transparent text-gray-500 hover:text-gray-800',
          )}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  </div>
);

export default AppsCatalogHeader;
